// Reaproveita o utilitário de WhatsApp que já existe no projeto (SupportModal),
// para não duplicar a lógica do link com mensagem pré-preenchida.
import { getWhatsAppLink } from '../../../components/SupportModal';

// Abertura padrão: identifica ao atendente que o contato veio do e-commerce.
const ECOMMERCE_PREFIX =
  'Olá! Estava contratando o plano pelo e-commerce da Santa Casa Copacabana';

// Link do WhatsApp já com a DÚVIDA do cliente embutida.
export function buildDoubtWhatsAppLink(pergunta) {
  const p = (pergunta || '').trim();
  const mensagem = p
    ? `${ECOMMERCE_PREFIX} quando me deparei com a seguinte dúvida: "${p}". Poderia me ajudar, por favor?`
    : `${ECOMMERCE_PREFIX} e fiquei com uma dúvida. Poderia me ajudar, por favor?`;
  return getWhatsAppLink(mensagem);
}

// Link do WhatsApp para "falar com um atendente" (sem uma dúvida específica).
export function buildAttendantWhatsAppLink() {
  return getWhatsAppLink(
    `${ECOMMERCE_PREFIX} e gostaria de falar com um atendente, por favor.`
  );
}

export { getWhatsAppLink };
